import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { useAuthenticationContext } from "../../context";
import { useGetRequestOptions } from "../../hooks";
import { API_URL } from "../../constants";

export type CustomWorklistFieldsReqBody = {
  study_ids: string[];
}

export const useGetCustomWorklistFields = () => {
  const { authToken } = useAuthenticationContext();
  const options = useGetRequestOptions(authToken);

  return useMutation({
    mutationFn: (body: CustomWorklistFieldsReqBody) =>
      axios.post(`${API_URL}v1/worklist-extra-columns`, body, options),
  });
};
